'use strict';

/**
 * Country sites template
 * @param {Object} facette
 * @param {Object} facette.values
 * @param {Object} facette.values.level1
 * @param {Object} facette.values.level2
 * @param {Object} wordings
 * @param {Array.<String>} arrCoordinates
 * @param {String} staticUrl
 * @return {String} - Country template string
 */
const templateCountrySite = function (facette, wordings, arrCoordinates, staticUrl) {
  let htmlCountries = '',
    htmlChecked = '',
    htmlDisabled = '',
    htmlCountryMap = '',
    coordinates = '',
    isOneCountryOpen = false,
    listHeaderClass = '',
    displayCountryOptions = '';
  const isSunParks = GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'SP';

  // On construit le html de l'élément du dernier niveau vers le premier pour permettre les concaténations
  $.each(facette.values.level1, (index, country) => {
    coordinates = arrCoordinates['country_' + country.code];

    // Gestion des sites
    const isCountrySelected = country.selected,
      sites = facette.values.level2[index];

    let htmlSites = '',
      htmlMapSubItems = '',
      htmlRegion = '',
      isCountryOpen = country.enabled ? isCountrySelected : false;

    $.each(sites, (idx, site) => {
      htmlChecked = site.selected || isCountrySelected ? ' checked="checked"' : '';

      htmlDisabled = site.enabled ? '' : ' u-disabled';
      const ckbxDisabled = site.enabled ? '' : ' disabled';

      if (site.selected && site.enabled) {
        isCountryOpen = true;
      }

      if (typeof site.region[GLOBAL_SCRIPTS.LANGUAGE_CODE] !== 'undefined' && site.region[GLOBAL_SCRIPTS.LANGUAGE_CODE] !== '') {
        htmlRegion = `<span class="searchForm-region u-Visible-mobile">${site.region[GLOBAL_SCRIPTS.LANGUAGE_CODE]}</span>`;
      }

      let productLabel = '';
      if (site.isNew || site.isRenovated) {
        if (site.isNew) {
          productLabel = `<span class="productLabel">${wordings.product_label_new}</span>`;
        } else if (site.isRenovated) {
          productLabel = `<span class="productLabel">${wordings.product_label_renovated}</span>`;
        }
      }

      if (site.distance) {
        productLabel = productLabel + geoloc.distance.renderLabel({value: site.distance});
      }

      htmlSites += `
        <li>
          <div class="form-checkboxContainer js-countryCheckbox${htmlDisabled}">
            <input name="facet[COUNTRYSITE][]"
                   id="facette_country_site_${site.code}"
                   value="${site.key}"
                   data-label="${site.value}"
                   class="form-checkbox" type="checkbox"${htmlChecked}${ckbxDisabled}>
            <label for="facette_country_site_${site.code}" class="form-checkboxLabel form-label">
              <span class="searchForm-siteLabel js_siteLabel">
                ${site.value}
              </span>
              ${productLabel}
              ${htmlRegion}
            </label>
          </div>
        </li>`;

      const siteLatitude = site.lat, siteLongitude = site.lon;

      htmlMapSubItems += `
        <span class="api_customMapPoint searchForm-sitePin js-searchForm-sitePin icon icon-placeholder${htmlDisabled}"
              data-lat="${siteLatitude}"
              data-long="${siteLongitude}"
              id="pin_${site.code}"
              data-input="#facette_country_site_${site.code}"
              title="${site.value}"></span>`;
    });

    //gestion de la map
    htmlCountryMap = `<div class="countryMap-container api_customMap u-Hidden-mobile"
        data-map_x_left="${coordinates.left}"
        data-map_x_right="${coordinates.right}"
        data-map_y_top="${coordinates.top}"
        data-map_y_bottom="${coordinates.bottom}">
      <picture>
        <img data-original="${staticUrl}/assets/images/domainMap/domain-map-country_${country.code}${isSunParks ? '--SP' : ''}.svg" alt="${country.value}" class="lazy" src="${staticUrl}/assets/images/domainMap/domain-map-country_${country.code}${isSunParks ? '--SP' : ''}.svg">
        <noscript>
          <img src="${staticUrl}/assets/images/domainMap/domain-map-country_${country.code}${isSunParks ? '--SP' : ''}.svg" alt="${country.value}" />
        </noscript>
      </picture>
      <span class="searchForm-referencePin api_customMapPoint">
        ${coordinates.reference}
      </span>
      ${htmlMapSubItems}
    </div>`;

    // Gestion des pays
    htmlChecked = country.selected ? ' checked="checked"' : '';
    htmlDisabled = country.enabled ? '' : ' u-disabled';
    listHeaderClass = isCountryOpen && !isOneCountryOpen ? ' opened' : '';
    displayCountryOptions = isCountryOpen && !isOneCountryOpen ? ' style="display: block"' : '';
    isOneCountryOpen = !isOneCountryOpen && isCountryOpen ? true : isOneCountryOpen;
    const dataDisabled = country.enabled ? '' : 'disabled';
    const geolocBtn = `<li class="searchForm-distanceContainer u-Hidden-mobile">
    <button type="button" class="searchForm-distance button button--whiteGreen button--withDiagonalArrow js-geolocDistance">
      <span class="searchForm-distanceTextShow">${wordings.geoloc_distance_show}</span>
      <span class="searchForm-distanceTextHide">${wordings.geoloc_distance_hide}</span>
    </button>
  </li>`;

    htmlCountries += `
     <li class="searchForm-listContainer searchForm-country${htmlDisabled}">
        <a data-id="facette_country_site_country_${country.code}" class="searchForm-listHeader js-optionListToggle${listHeaderClass}" href="#" data-key="${country.code}">
          ${country.value}
          <span class="searchForm-countryQuantity js-quantity"></span>
          <i class="icon icon-arrow-right u-Hidden-mobile"></i>
          <i class="icon icon-arrow u-Visible-mobile"></i>
          <input id="facette_country_site_country_${country.code}" class="facette_country_site js-country_${country.code}-input" name="country" value="l1_${country.code}" type="hidden" data-label="${country.value}" data-disable="${dataDisabled}">
        </a>
        <ul class="searchForm-optionsList searchForm-countryOptionsList js-country_${country.code} searchForm-country_${country.code}"${displayCountryOptions}>
          <li class="searchForm-countrySelector">
            <div class="form-checkboxContainer js-checkbox-selectAll">
              <input name="facet[COUNTRYSITE][]" id="optionList_country_${country.code}_seeAll" value="${country.key}" class="form-checkbox"${htmlChecked} type="checkbox">
              <label for="optionList_country_${country.code}_seeAll" class="form-checkboxLabel form-label">
                ${country.value}
              </label>
            </div>
            ${htmlCountryMap}
          </li>
          ${htmlSites}
          ${isSunParks ? geolocBtn : ''}
        </ul>
      </li>`;
  });
  // Concaténation finale
  return htmlCountries;
};

export { templateCountrySite };